import { doodBlockConfig, propertyValue } from './dood-block-config';
import {
  buildOrderedBlockDescriptor,
  type DescriptorFieldOrderItem,
} from './descriptor-field-order';
import type { IBlockDescriptor } from './descriptor';

export const INFORMATIONSCOLUMNBLOCK_LEGACY_FIELD_ORDER = [
  "title",
  "icon"
] as const satisfies readonly DescriptorFieldOrderItem[];

const {
  informationsColumnBlockDescriptor: _generatedInformationsColumnBlockDescriptor,
  informationsColumnBlockBlocDefinition,
  informationsColumnBlockDashboardLayout,
  informationsColumnBlockConfig,
  informationsColumnBlockResolveConfig,
  informationsColumnBlockProperties,
} = doodBlockConfig(
  {
    name: "Informations column",
    componentType: 'InformationsColumnBlockComponent',
    category: 'content',
    hideFromPicker: true,
    description: "Informations column.",
    keywords: [],
    allowedIn: [
      { bloc: "InformationsContainerBlockComponent", slot: "columns" },
    ],
    sharedFields: {},
    slots: [
      {
        key: 'columns',
        name: 'pages.blocks.informations-column.columns.label',
        accept: 'explicitOnly',
        allowedTypes: ["TextBlock", "InformationsRowBlock"],
        slotItemFormat: 'ids',
      }
    ]
  },

  () => ({
    title: propertyValue({
      type: 'text',
      value: '',
      options: {
        label: "pages.blocks.informations-column.title.label",
      }
    }),
    icon: propertyValue({
      type: 'text',
      value: '',
      options: {
        label: "pages.blocks.informations-column.icon.label",
        help: "pages.blocks.informations-column.icon.help",
      }
    })
  }),

  () => ({
    tabs: [
      {
        label: "pages.blocks.informations-column.tab.content.label",
        fieldsets: [
          {
            legend: "pages.blocks.informations-column.fieldset.title.label",
            fields: ["title", "icon"],
          },
          {
            legend: "pages.blocks.informations-column.fieldset.blocks.label",
            fields: ["columns"],
          },
        ],
      },
    ],
  })
);

export function informationsColumnBlockDescriptor(): IBlockDescriptor;
export function informationsColumnBlockDescriptor(
  fieldOrder: readonly DescriptorFieldOrderItem[],
): IBlockDescriptor;
export function informationsColumnBlockDescriptor(
  fieldOrder?: readonly DescriptorFieldOrderItem[],
): IBlockDescriptor {
  if (fieldOrder === undefined) {
    return _generatedInformationsColumnBlockDescriptor;
  }
  return buildOrderedBlockDescriptor(_generatedInformationsColumnBlockDescriptor, informationsColumnBlockProperties, fieldOrder);
}

export {
  informationsColumnBlockBlocDefinition,
  informationsColumnBlockDashboardLayout,
  informationsColumnBlockProperties,
  informationsColumnBlockConfig,
  informationsColumnBlockResolveConfig,
};

export type InformationsColumnBlockConfig = typeof informationsColumnBlockConfig;
